export default "__VITE_PUBLIC_ASSET__36405fbf__"